<ambita-cadastre-report-disclaimer>
  <div class="ambita-cadastre-report__default-text">
    <h5 class="ambita-cadastre-report-disclaimer__title ambita-report-h5">
      { i18n.propertyLookup.responsibilityTitle }
    </h5>
    <span>{ i18n.propertyLookup.responsibility }</span>
  </div>
  <script>
    import i18nMixin from '../i18nMixin';

    this.mixin(i18nMixin);
  </script>
</ambita-cadastre-report-disclaimer>
